export const createSoundConfig = (startAt, frequency, length = 0, gain = 1, type) => ({
  frequency,
  gain,
  length,
  startAt,
  type
});